import { createTableColumns } from "./tableConfig";
import { Table } from "components/shared/Table";
import { PartnerProposalMetricsTableDataResponse } from "modules/aftermarketPartner/api/types";
import { Column } from "react-table";

export const ReportsTable = ({
  partnerView,
  metricsData,
  loading,
  columns,
}: {
  partnerView: boolean;
  metricsData: any;
  loading: boolean;
  columns: Column<any>[];
}) => {
  return <Table<PartnerProposalMetricsTableDataResponse> tableData={metricsData} columns={columns} loading={loading} />;
};
